import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllBusinessTypesService = ({
  enableQuery,
  page = "1",
  per_page = "15",
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const allBusinessTypes = useQuery({
    queryKey: [...CACHE_KEYS.BUSINESS_TYPES, page, per_page, debouncedQuery],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.BUSINESS_TYPES,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allBusinessTypes },
    states: { searchQuery, setSearchQuery },
  };
};
